<template>
  <div>
    <div class="recommend-header">推薦文章</div>
    <div v-for="blog in blogs" :key="blog.slug_name">
      <recommend-blog-item :blog="blog" />
    </div>
    <div class="button-read-more" onclick="window.location.href='/blog'">
      來看更多專欄文章
    </div>
  </div>
</template>
<script>
import RecommendBlogItem from "@/components/blogs/RecommendBlogItem";

export default {
  name: "RecommendBlogList",
  props: ["blogs"],
  components: { RecommendBlogItem },
};
</script>
<style lang="scss" scoped>
.button-read-more {
  margin: 78px auto 30px;
  width: 261px;
  border-radius: 32px;
  background-color: #106772;
  font-family: "Noto Sans TC", sans-serif;
  font-size: 18px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1;
  padding: 18px 0;
  letter-spacing: 0.72px;
  text-align: center;
  color: #ffffff;
  cursor: pointer;
  &:hover {
    box-shadow: 2px 2px 6px 0 #8ea798;
    background-color: #00c8a5;
  }
  @media (min-width: 640px) and (max-width: 1119.98px) {
    margin: 74px auto 5px;
    width: 315px;
    font-size: 20px;
    letter-spacing: 0.8px;
    line-height: 1;
    border-radius: 32px;
    padding: 22px 0;
  }
  @media (min-width: 1120px) {
    width: 285px;
    margin: 85px auto 102px;
    font-size: 20px;
    letter-spacing: 0.8px;
    border-radius: 32px;
    line-height: 1;
    padding: 22px 0;
  }
}
.recommend-header {
  padding: 29px 0 18px;
  font-family: "Noto Sans TC", sans-serif;
  font-size: 22px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.86;
  letter-spacing: 0.66px;
  text-align: center;
  color: #003232;
  border-bottom: solid 0.5px #106772;
  @media (min-width: 640px) and (max-width: 1119.98px) {
    padding: 45px 0 28px;
    font-size: 22px;
    line-height: 1.86;
    letter-spacing: 0.66px;
  }
  @media (min-width: 1120px) {
    padding: 56px 0 48px;
    font-size: 22px;
    line-height: 1.86;
    letter-spacing: 0.66px;
  }
}
</style>